import * as React from "react";
import { ContractType } from "../../__generated__/globalTypes";
import CardHESP from "../CardHESP/CardHESP";
import CardHESPTitle from "../CardHESP/CardHESPTitle";
import ContractPAYG from "../Contracts/ContractPAYG";
import ContractCommitment from "../Contracts/ContractCommitment";
import { GetFullOrganizationDetails_organization } from "../../views/App/__generated__/GetFullOrganizationDetails";
import { Button } from "@mui/material";
import { CalendarMonth } from "@mui/icons-material";
import EditContractDialog from "../Contracts/EditContractDialog";

interface Props {
    organization: GetFullOrganizationDetails_organization;
}

function OrganizationContract({ organization }: Props) {
    const { contractType } = organization;

    const [openEditContractDialog, setOpenEditContractDialog] = React.useState<boolean>(false);

    function getContractComponent() {
        switch (contractType) {
            case ContractType.payg:
                return <ContractPAYG organization={organization} />;
            case ContractType.commitment:
                return <ContractCommitment organization={organization} />;
        }
    }

    return (
        <>
            <CardHESP>
                <CardHESPTitle
                    title="Contract information"
                    button={
                        contractType === ContractType.commitment ? (
                            <Button
                                color="primary"
                                startIcon={<CalendarMonth />}
                                variant="contained"
                                onClick={() => setOpenEditContractDialog(true)}
                            >
                                New contract period
                            </Button>
                        ) : undefined
                    }
                />
                {getContractComponent()}
            </CardHESP>
            {contractType === ContractType.commitment && (
                <EditContractDialog
                    organization={organization}
                    open={openEditContractDialog}
                    onClose={() => setOpenEditContractDialog(false)}
                />
            )}
        </>
    );
}

export default OrganizationContract;
